import { MuiProvider } from './MuiProvider';

export default MuiProvider;
